import React, { useEffect, useState } from 'react';
import {
    getIntroVideoThumbnailFallbackUrl,
    getIntroVideoThumbnailUrl,
    isVerticalIntroVideoUrl,
} from '../utils/mediaKitVideoUtils';

interface MediaKitIntroReelProps {
    introVideoUrl: string;
    onPlay: () => void;
}

export default function MediaKitIntroReel({ introVideoUrl, onPlay }: MediaKitIntroReelProps) {
    const [thumbnailUrl, setThumbnailUrl] = useState(() => getIntroVideoThumbnailUrl(introVideoUrl));
    const isVertical = isVerticalIntroVideoUrl(introVideoUrl);

    useEffect(() => {
        setThumbnailUrl(getIntroVideoThumbnailUrl(introVideoUrl));
    }, [introVideoUrl]);

    const handleThumbnailError = () => {
        const fallback = getIntroVideoThumbnailFallbackUrl(introVideoUrl);
        if (fallback && thumbnailUrl !== fallback) {
            setThumbnailUrl(fallback);
        }
    };

    return (
        <div
            className={`media-kit-video-thumb${isVertical ? ' media-kit-video-thumb--vertical' : ''}`}
            onClick={onPlay}
            onKeyDown={(e) => e.key === 'Enter' && onPlay()}
            role="button"
            tabIndex={0}
            aria-label="Play intro reel"
        >
            {thumbnailUrl && (
                <img
                    className="media-kit-video-thumb-image"
                    src={thumbnailUrl}
                    alt=""
                    onError={handleThumbnailError}
                />
            )}
            <div className="media-kit-play-btn" aria-hidden="true">
                <span className="media-kit-play-triangle" />
            </div>
        </div>
    );
}
